export const explor = [
    {
        id: 1,
        name: "VEG",
        // price: 15.99,
        // description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/Frame 1.png"
    },
    {
        id: 2,
        name: "NON-VEG",
        // price: 10.99,
        // description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/Frame 2.png"
    },
    {
        id: 3,
        name: "Today's Special",
        // price: 10.99,
        // description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "/images/Frame 3.png"
    },
    {
        id: 4,
        name: "Diet Chart",
        // price: 20.99,
        // description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image:"/images/Frame 4.png"
    }
]